(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_brk-ugc"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var card = e.target.closest('.brk-ugc__card');
    if (!card) return;
    if (e.target.closest('.brk-ugc__cta')) return;
    var video = card.querySelector('video');
    if (!video) return;
    document.querySelectorAll('.brk-ugc__card.is-playing').forEach(function (other) {
      if (other !== card) {
        var v = other.querySelector('video');
        if (v) v.pause();
        other.classList.remove('is-playing');
      }
    });
    if (video.paused) {
      video.play();
      card.classList.add('is-playing');
    } else {
      video.pause();
      card.classList.remove('is-playing');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
